import {
  BlockConfigAreaRequest,
  DeleteConfigAreaRequest,
  LimitStackHeightConfigAreaRequest,
  ReeferPlugConfigAreaRequest,
  SpaceBetweenBaysConfigAreaRequest,
  YardConfigsApi,
} from '@yard/app/api'
import { createApiClient } from '@yard/app/http-client'

class YardConfigService {
  private readonly httpClient = createApiClient(YardConfigsApi)

  async blockConfigArea(request: BlockConfigAreaRequest) {
    const { data } = await this.httpClient.blockConfigArea(request)
    return data.id
  }

  async deleteConfigArea(request: DeleteConfigAreaRequest) {
    await this.httpClient.deleteYardConfigArea(request)
  }

  async limitStackHeightConfigArea(request: LimitStackHeightConfigAreaRequest) {
    const { data } = await this.httpClient.limitStackHeightConfigArea(request)
    return data.id
  }

  async reeferPlugConfigArea(request: ReeferPlugConfigAreaRequest): Promise<string> {
    const { data } = await this.httpClient.reeferPlugConfigArea(request)
    return data.id
  }

  async spaceBetweenBaysConfigArea(request: SpaceBetweenBaysConfigAreaRequest): Promise<string> {
    const { data } = await this.httpClient.spaceBetweenBaysConfigArea(request)
    return data.id
  }
}

export const yardConfigService = new YardConfigService()
